import { KzIconGlobe } from '@kaizenplatform/kaizen-icon-elements';

export const registerCustomElements = (registry: CustomElementRegistry) => {
  registry.define(KzIconGlobe.is, KzIconGlobe);
};
